import PersonalDetails from "./PersonalDetails";
import ContactDetails from "./ContactDetails";
import Photo from "./Photo";
import LoginDetails from "./LoginDetails";
import Address from "./Address";
import Role from "./Role";
import { Card, CardBody} from "reactstrap";
import Loader from "react-loaders";
import { useGebruikerContext } from "../../Context/GebruikerContext";
import { AlgemeenProvider } from "./Context/AlgemenContext";


const Algemeen = ({ children }) => {
	const { isLoading } = useGebruikerContext();

	if (isLoading) {
		return (
			<Card className="main-card">
				<CardBody className="d-flex flex-column">
					<Loader
						type="ball-grid-pulse"
						className={"mt-3 d-flex mx-auto justify-content-center"}
					/>
				</CardBody>
			</Card>
		);
	}

	return (
		<AlgemeenProvider>{children}</AlgemeenProvider>
	);
};

Algemeen.Wrapper = ({ children }) => {
	return <div className="row algemeen">{children}</div>;
};

Algemeen.PersonalDetails = () => {
	return (
		<div className="col-xxl-4 col-lg-6">
			<PersonalDetails />
			<div className="mt-4">
				<Algemeen.Address />
			</div>
		</div>
	);
};


Algemeen.Subwrapper = ({ children }) => {
	return (
		<div className="col-xxl-8 col-lg-6 ">
			<div className="row">{children}</div>
		</div>
	);
};

Algemeen.ContactDetails = () => {
	return (
		<div className="col-xxl-6 col-12">
			<ContactDetails />
		</div>
	);
};

Algemeen.Photo = () => {
	return (
		<div className="col-xxl-6 col-12 ">
			<Photo />
		</div>
	);
};

Algemeen.LoginDetails = () => {
	return (
		<div className="col-xxl-6 col-12 custom-gutter">
			<LoginDetails />
		</div>
	);
};

Algemeen.Role = () => {
	return (
		<div className="col-xxl-6 col-12 custom-gutter">
			<Role />
		</div>
	);
};

Algemeen.Address = () => {
	return (
		<div className="col-xxl-12 col-12  ">
			<Address />
		</div>
	);
};

export default Algemeen;
